// @flow

import type { Node } from 'react';

type Props = {
  children: Function,
};

/**
 * CmsModuleFunction
 *
 * @param {Props} props
 * @returns {Node}
 */
export function CmsModuleFunction({ children, ...props }: Props): Node {
  return children(props);
}
